import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { CRMService } from '../../services/crm.service';
import { EmployeeService } from '../../services/employees.service';
import { CustomerStatus, SearchCRMFollowUp, SearchCRMOpportunity, SearchCustomer } from '../../models/models';

@Component({
    selector: 'crm-home',
    templateUrl: './crm-home.component.html',
    standalone: false
})
export class CrmHome implements OnInit {
    public isLoading: boolean = false;
    public repType: string = '';
    public employeeId: number = 0;

    public customerStatusList: CustomerStatus[] = [];
    public accountStatusCount: { id: number, count: number }[] = [];
    public accounts: SearchCustomer[] = [];
    public prospects: SearchCustomer[] = [];
    public followUps: SearchCRMFollowUp[] = [];
    public opportunities: SearchCRMOpportunity[] = [];

    public untouchedLeadsCount: number = 0;
    public assignedLeadsCount: number = 0;
    public lateSWLeadCount: number = 0;
    public prospectCount: number = 0;
    public drawingPainCount: number = 0;
    public rapportBuildingCount: number = 0;
    public pastDueCount: number = 0;
    public todayCount: number = 0;
    public comingDueCount: number = 0;
    public quoteAndBudgetCount: number = 0;
    public finalistCount: number = 0;
    public preAwardCount: number = 0;
    public closingSoonCount: number = 0;

    constructor(private crmService: CRMService, private employeeService: EmployeeService, private router: Router, private titleService: Title,
    private route: ActivatedRoute) {
        titleService.setTitle('CRM Home');
    }

    ngOnInit() {
        this.route.params.subscribe(params => {
            this.repType = params.repType;
            this.employeeId = params.employeeId;

            this.getCustomerStatuses();
        });
    }

    private getData() {
        this.getLeads();
        this.getProspects();
        this.getOpportunities();
        this.getFollowUps();
    }

    private getCustomerStatuses() {
        this.crmService.getCustomerStatuses().subscribe(result => {
            // Prepoluate with all but Lead, SW Lead, Disqualified
            this.customerStatusList = result;
            this.customerStatusList = this.customerStatusList.filter(t => t.retiredInd != true && t.abbreviation != "Disqualified");
            this.customerStatusList = this.customerStatusList.sort((left, right): number => {
                if (left.stage < right.stage) return -1;
                if (left.stage > right.stage) return 1;
                return 0;
            });
            this.getData();
        });
    }

    public getCustomerStatusCount(customerStatusID: number) {
        //var statusList = this.accounts.filter(t => t.customerStatusID == customerStatusID);
        //return statusList.length;
        var statusCount = this.accountStatusCount.find(t => t.id == customerStatusID)!;
        //console.log("getCustomerStatusCount", customerStatusID, statusList.length);
        return statusCount.count;
    }

    private getLeads() {
        this.isLoading = true;
        if (this.employeeId < 1) {
            this.crmService.getSearchCustomer().subscribe(result => {
                this.isLoading = false;
                this.setLeadCounts(result.resultCollection);
            });
        } else {
            this.crmService.getSearchCustomerByRepTypeEmployeeID(this.repType, this.employeeId).subscribe(result => {
                this.isLoading = false;
                this.setLeadCounts(result.resultCollection);
            });
        }
    }

    private getProspects() {
        this.crmService.getSearchCustomerProspectsByEmployeeID(this.employeeId).subscribe(result => {
            this.prospects = result.resultCollection;
            this.crmService.prospects = result.resultCollection;
            this.prospectCount = this.prospects.filter(p => p.customerStatus == 'Prospect').length;
            this.drawingPainCount = this.prospects.filter(p => p.customerStatus == 'Drawing Pain').length;
            this.rapportBuildingCount = this.prospects.filter(p => p.customerStatus == 'Rapport Building').length;
        });
    }

    private getOpportunities() {
        this.crmService.getSearchCRMOpportunityByEmployeeID(this.employeeId).subscribe(result => {
            var oneWeek = new Date();
            oneWeek.setDate(oneWeek.getDate() + 7);
            this.opportunities = result.resultCollection;
            this.crmService.opportunities = result.resultCollection;
            this.quoteAndBudgetCount = this.opportunities.filter(o => o.salesCycleDescription == 'Budget & Quote').length;
            this.finalistCount = this.opportunities.filter(o => o.salesCycleDescription == 'Finalist(50-75% win)').length;
            this.preAwardCount = this.opportunities.filter(o => o.salesCycleDescription == 'Pre-Award (90%)').length;
            this.closingSoonCount = this.opportunities.filter(o => new Date(o.expectedCloseDate) < oneWeek).length;
        });
    }

    private getFollowUps() {
        this.crmService.getSearchCRMFollowUpByEmployeeID(this.employeeId).subscribe(result => {
            this.followUps = result.resultCollection;

            this.followUps.forEach(a => {
                a.followUpDate = new Date(a.followUpDate);
            });

            //if (this.employeeId > 0) {
            //    this.followUps = this.followUps.filter(f => f.assignedToEmployeeID == this.employeeId);
            //}

            this.crmService.followUps = this.followUps;

            var beginToday = new Date();
            var endToday = new Date();
            var lastSunday = new Date();
            var nextSunday = new Date();

            beginToday.setHours(0, 0, 0, 0);
            endToday.setHours(23, 59, 59, 999);
            lastSunday.setDate(lastSunday.getDate() - lastSunday.getDay());
            lastSunday.setHours(0, 0, 0, 0);
            nextSunday.setDate(beginToday.getDate() + (7 + 0 - beginToday.getDay()) % 7);
            nextSunday.setHours(23, 59, 59, 999);

            this.pastDueCount = this.followUps.filter(f => f.followUpDate < beginToday).length;
            this.comingDueCount = this.followUps.filter(f => f.followUpDate > endToday && f.followUpDate < nextSunday).length;
            this.todayCount = this.followUps.filter(f => f.followUpDate > beginToday && f.followUpDate < endToday).length;
        });
    }

    private setLeadCounts(leads: SearchCustomer[]) {
        this.accounts = leads;
        this.crmService.accounts = leads;
        this.accountStatusCount = [];
        for (var i = 0; i < this.customerStatusList.length; i++) {
            var statusList = this.accounts.filter(t => t.customerStatusID == this.customerStatusList[i].customerStatusId);
            this.accountStatusCount.push({ id: this.customerStatusList[i].customerStatusId, count: statusList.length });
        }
        this.untouchedLeadsCount = this.accounts.filter(l => l.noActionsInd == true).length;
        this.assignedLeadsCount = this.accounts.filter(l => l.accountRepID == this.employeeId || l.salesEmployeeID == this.employeeId || l.opsRepID == this.employeeId).length;
        this.lateSWLeadCount = this.accounts.filter(l => l.lateSpiderWebLead == true).length;
    }
}